@if(!inIframe || showHeader) {
  <div class="main-body">
    <app-header [hideToggle]="true" (onClickLogo)="redirectToDashboard()"
      (reloadPage)="reloadCurrentRoute()"></app-header>
    <div class="main-body-scroll-area" style="height: calc(100% - 50px); overflow:auto;">
      <div class="main-view">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
}

@if(inIframe && !showHeader) {
  <router-outlet></router-outlet>
}